/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItem_viewer$ref: FragmentReference;
export type PdpRespSimilarItem_viewer = {|
  +isSeoQuicklookEnabled: ?boolean,
  +isFavoritesEnabled: ?boolean,
  +$refType: PdpRespSimilarItem_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItem_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7c25128694f1321b4000ed8c8b6a13c3';
module.exports = node;
